<template lang="pug">
  .solicitud
    b-card()
      template(#header='')
        h6.mb-0 Visualizar Solicitud de Información
      b-card-text
        b-tabs(pills='' content-class='mt-3')
          b-tab(title='Visualizar')
            div
              form.px-2
                .form-group.row
                  b-form-group#input-group-0.col-sm-3.col-form-label(label='Fecha:' label-for='input-fecha')
                  .col-sm-7
                    b-form-group(:label='solicitudInformacion.fecha_creacion.slice(0, 16)')
                .form-group.row
                  b-form-group#input-group-2.col-sm-3.col-form-label(label='Estado:' label-for='input-tipo')
                  .col-sm-7
                    b-form-group(:label='solicitudInformacion.descripcion_estado')
                .form-group.row
                  b-form-group#input-group-1.col-sm-3.col-form-label(label='Tema:' label-for='input-tema')
                  .col-sm-7
                    b-form-group(:label='solicitudInformacion.tema')
                .form-group.row
                  b-form-group#input-group-3.col-sm-3.col-form-label(label='Descripcion' label-for='input-descripcion')
                  .col-sm-7
                    b-form-group#input-descripcion(:label='solicitudInformacion.descripcion')
                .form-group.row
                  b-form-group#input-group-2.col-sm-3.col-form-label(label='Tipo de Solicitud de Informacion:' label-for='input-tipo')
                  .col-sm-7
                    b-form-group(:label='solicitudInformacion.descripcion_tipo')

                .form-group.row
                  b-form-group#input-group-4.col-sm-3.col-form-label(label='Fecha Fin de Recepcion de Respuestas:' label-for='input-fecha-fin-recepcion')
                  .col-sm-7
                    b-form-group(:label='solicitudInformacion.recepcion_propuesta_fecha_fin.slice(0, 16)')
                .form-group.row
                  b-form-group#input-group-6.col-sm-3.col-form-label(label='Fecha de Reunion Informativa' label-for='input-fecha-reunion')
                  .col-sm-7
                    b-form-group(:label='solicitudInformacion.reunion_informativa_fecha')
                .form-group.row
                  b-form-group#input-group-7.col-sm-3.col-form-label(label='Lugar de Reunion Informativa' label-for='input-lugar-reunion')
                  .col-sm-7
                    b-form-group(:label='solicitudInformacion.reunion_informativa_lugar')

                .form-group
                  div()
                    .card.table-panel(id='')
                      .card-header
                        h3.card-title
                          | Contactos
                      .card-body.table-responsive
                        table.table.table-bordered.table-condensed.table-striped.table-hover
                          thead
                            tr
                              th.text-center.w-25 Nombre
                              th.text-center.w-25 Cargo
                              th.text-center.w-25 Correo Electronico
                              th.text-center.w-25 Telefono
                          tbody()

                            tr( v-for='(row,index) in listaContactos')
                              td.text-center  {{row.nombre}}
                              td.text-center {{row.cargo}}
                              td.text-center {{row.correo_electronico}}
                              td.text-center {{row.telefono}}



              table.table.table-bordered.table-condensed.table-striped.table-hover(v-if = 'archivoList.length > 0')
                thead
                  tr
                    th.text-center.w-25 Nombre
                    th.text-center.w-25 Fecha Adjunto
                    th.text-center.w-25 Fecha Publicacion
                    th.text-center.w-25 Acciones
                tbody()
                  tr( v-for='(row,index) in archivoList')
                    td.text-center {{row.nombre_archivo}}
                    td.text-center {{row.fecha_archivo}}
                    td.text-center
                    td.text-center
                      .btn-group
                        b-dropdown.m-md-1(text='Acciones')
                          b-dropdown-item(@click.prevent='obtenerArchivo(row)') Descargar


              div.float-right
                //button.btn.btn-primary.m-1(@click.prevent='eliminarRfi(solicitudInformacion)' v-if="_checkPerfil('rfi_convocante_admin') && !publicado" ) Eliminar
                //button.btn.btn-primary.m-1(@click.prevent='save(solicitudInformacion,"CANCELADO")' v-if="_checkPerfil('rfi_convocante_admin') && publicado" ) Cancelar
                button.btn.btn-primary.m-1(@click="mostrarModal(\"cancelar\")\n" v-if="_checkPerfil('rfi_convocante_admin') && publicado" ) Cancelar
                button.btn.btn-primary.m-1(@click="mostrarModal(\"eliminar\")\n" v-if="_checkPerfil('rfi_convocante_admin') && !publicado" ) Eliminar

              button.btn.btn-primary.m-1(@click.prevent='volver()') Volver

          b-tab(title='Invitados')
            Invitados(:rfi_id = 'this.id' :edit = 'false')
          b-tab(title='Documentos de las Respuestas')
            PropuestaTab(:rfi_id = 'this.id')
          b-tab(title='Historial' v-if="this._checkPerfil('rfi_funcionario_consulta')")
            Historial(:rfi_id = 'this.id')

          modal(:title="modalTitulo" :texto="modalTexto"
            :modalShow="modalShow"
            :button-action-name="modalBoton"
            @confirmed='confirmarAccionModal()'
            @close="cerrarAccionModal()"
            :isPublic="false"
          )

</template>

<script>
import Invitados from "../components/Invitados";
import {HTTP} from "../http";
import Historial from "../components/Historial";
import PropuestaTab from "../components/PropuestaTab";
import functions from "../mixins/functions";
import Modal from "../components/Modal";

export default {
  name: "SolicitudInformacionVisualizar",
  mixins: [functions],

  components: {
    PropuestaTab,
    Modal,
    Historial,
    Invitados
  },

  data() {
    return {
      id: null,
      solicitudInformacion: {},
      estadoRfiList: {},
      selected: null,
      tipoRfiList: [ ],
      date: null,
      archivoList: [],
      listaContactos: [],
      publicado: false,
      eliminar: false,
      cancelar: false,
      modalShow: false,
      modalTitulo: "",
      modalTexto: "",
      modalBoton: "",
    }
  },
  async created(){
    this.activeSpinner();
    window.scrollTo(0,0);
    try {
      this.id = this.$route.query.id;
      this.solicitudInformacion = (await HTTP.get('/solicitudInformacion/',{ params: {solicitudId: this.id}})).data
      this.estadoRfiList = (await HTTP.get('/selectores/parametros', { params: {dominio: "RFI_ESTADO"}})).data.list;
      this.tipoRfiList = (await HTTP.get('/selectores/parametros', { params: {dominio: "RFI_TIPO_SOLICITUD_INFORMACION"}})).data.list;
      this.listaContactos = (await HTTP.get('/solicitudInformacion/contacto/listar/',{ params: {solicitudId: this.id}})).data
      if(this.solicitudInformacion.estado_codigo == "PUBLICADO")
        this.publicado = true;
      await this.getArchivos();
      this.date= new Date().toISOString();

      if(this.solicitudInformacion.reunion_informativa_fecha != null)
        this.solicitudInformacion.reunion_informativa_fecha = this.solicitudInformacion.reunion_informativa_fecha.slice(0, 16)
    }catch (error) {
      console.log(error)
    }
    this.desactiveSpinner();


  },

  methods: {
    volver: function () {
      this.$router.push({path: "/"})
    },
    async getArchivos() {
      this.archivoList = (await HTTP.get('/archivo/listar', {params: {solicitudId: this.id}})).data;
    },

    save: async function (instance,estado) {

      instance.estado_codigo = estado;
      try {
        const data = await (HTTP.post('/solicitudInformacion/modificar', instance));
        await this.getArchivos(); //Se recupera la metadata de archivos asociados
        window.scrollTo(0,0);
        this.solicitudInformacion = (await HTTP.get('/solicitudInformacion/',{ params: {solicitudId: this.id}})).data
        this.$root.$emit('showNotificationSuccess', {mensaje: 'Se ha cancelado la Solicitud de Informacion'});
        console.log(data);
      } catch (error) {
        this.$root.$emit('showNotificationError', {mensaje: 'Ocurrio un error al modificar la Solicitud de Informacion'});
        console.log(error);
      }
    },

    eliminarRfi: async function (instance) {
      try {
        const data = await (HTTP.post('/solicitudInformacion/eliminarRfi', instance));
        this.$root.$emit('showNotificationSuccess', {mensaje: 'Se ha eliminado la Solicitud de Informacion'});
        this.$router.push({path: "/"})
        console.log(data);
      } catch (error) {
        window.scrollTo(0,0);
        this.$root.$emit('showNotificationError', {mensaje: 'Ocurrio un error al eliminar la Solicitud de Informacion'});
        console.log(error);
      }
    },

    mostrarModal(accion){
      this.modalShow = !this.modalShow
      if(accion =="cancelar"){
        this.modalTexto = "Desea cancelar la Solicitud de Informacion?"
        this.modalTitulo = "Cancelar Solicitud de Informacion"
        this.modalBoton = "Cancelar"
        this.cancelar = true ;
      } else if(accion =="eliminar"){
        this.modalTexto = "Desea eliminar la Solicitud de Informacion?"
        this.modalTitulo = "Eliminar Solicitud de Informacion"
        this.modalBoton = "Eliminar"
        this.eliminar = true ;

      }
    },

    confirmarAccionModal() {
      this.modalShow = !this.modalShow
      if(this.eliminar  == true){
        this.eliminarRfi(this.solicitudInformacion)
      }else if(this.cancelar == true){
        this.save(this.solicitudInformacion,"CANCELADO")
      }
    },

    cerrarAccionModal() {
      this.modalShow = !this.modalShow;
      this.eliminar = false;
      this.cancelar = false;
    },

    obtenerArchivo(instance) {
      HTTP.put('/archivo/obtenerArchivo', instance, {responseType: 'blob'})
          .then(result => {
            this.handleResponseArchivo(result.data, instance.nombre_archivo)
          })
          .catch(error => {
            window.scrollTo(0,0);
            this.$root.$emit('showNotificationError', {mensaje: 'Ocurrio un error al Obtener el archivo. ' + error.response.data});
          })
    },
    handleResponseArchivo(blobData, name) {
      console.log(blobData, name)
      let fileURL = window.URL.createObjectURL(blobData);
      let fileLink = document.createElement("a");
      fileLink.href = fileURL;
      fileLink.setAttribute("download", `${name}`);
      document.body.appendChild(fileLink);
      fileLink.click();
      fileLink.remove();
    }
  }
}
</script>

<style scoped>

</style>
